var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-info"},[_c('p',{staticClass:"firstLetterUppercase"},[_vm._v(_vm._s(_vm._f("formatDateDistance")(_vm.h.date.date))+" em "+_vm._s(_vm._f("formatDate")(_vm.h.date.date))+" "),_c('span',{staticClass:"withSeparator"},[_vm._v(_vm._s(_vm.h.person))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }